import React, { useState, memo } from "react";
import ImageViewer from "react-simple-image-viewer";
import { formatTime } from "../../../helpers/formatTime";
import {
  SingleImageWrapper,
  MultipleImages,
  ImageWrapper,
  MultipleImage,
  MoreImagesCount,
  MessaageMain,
  MessageText,
  MessageAction,
} from "./styles/MessagesStyles";

const ReceiverMessage = ({ message = [], date, attachments = [] }) => {
  const MAX_VISIBLE_IMAGES = 4;
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const openImageViewer = (index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const isAttachmentsArrayNotEmpty =
    Array.isArray(attachments) && attachments.length > 0;

  const handleImageClick = () => {
    openImageViewer();
  };
  return (
    <MessaageMain className="reciver_message_main">
      {isAttachmentsArrayNotEmpty && (
        <>
          {attachments.length === 1 ? (
            <>
              <SingleImageWrapper
                style={{ backgroundImage: `url(${attachments[0].url})` }}
                onClick={handleImageClick}
                className="SingleImageWrapper"
              />
            </>
          ) : (
            <>
              <MultipleImages
                className={`receiver_Images ${
                  attachments.length === 1 ? "singleImageWrap" : ""
                }`}
              >
                {attachments
                  .slice(0, MAX_VISIBLE_IMAGES)
                  .map((image, index) => (
                    <ImageWrapper
                      key={index + image?.url}
                      className="ImageWrapper"
                      onClick={() => openImageViewer(index)}
                    >
                      {index === MAX_VISIBLE_IMAGES - 1 &&
                        attachments.length > MAX_VISIBLE_IMAGES && (
                          <MoreImagesCount>
                            +{attachments.length - MAX_VISIBLE_IMAGES}
                          </MoreImagesCount>
                        )}
                      <MultipleImage src={image?.url} alt="messages" />
                    </ImageWrapper>
                  ))}
              </MultipleImages>
            </>
          )}
        </>
      )}
      {/* {!isImage && !isMultipleImages && ( */}
      {message && (
        <MessageText
          className={`receiver_message_text ${
            attachments?.length > 0 && "text_have_attachments"
          }`}
        >
          {message}
        </MessageText>
      )}
      {/* )} */}
      <MessageAction className="reciver_message_action">
        <span>{formatTime(date)}</span>
      </MessageAction>
      {isViewerOpen && (
        <ImageViewer
          src={attachments?.map((attachment) => attachment?.url)}
          currentIndex={currentImage}
          onClose={closeImageViewer}
          backgroundStyle={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
          disableScroll={false}
          closeOnClickOutside={true}
        />
      )}
    </MessaageMain>
  );
};

export default memo(ReceiverMessage);
